module.exports = __webpack_public_path__ + "static/media/daas_overlay-fs8.781ca457.png";